import { gql } from '@common/hooks';

export const STAFFING_REQUEST_APPLICATION_INFO_FRAGMENT = gql`
  fragment StaffingRequestApplicationInfo on StaffingRequestApplication {
    id
    organization {
      id
      name
      organizationSetting {
        id
        timekeepingEnabled
      }
    }
    worksProfile {
      id
      fullName
    }
    staffingRequest {
      id
      code
      externalId
      startDate
      endDate
      billingRegularRate
      shiftType
      shiftsPerWeek
      hoursPerShift
      staffingRequestType
      role {
        id
        abbreviation
      }
      organizationUnit {
        id
        department {
          id
          name
          organizationBusiness {
            id
            name
            city
            stateCode
          }
        }
      }
    }
  }
`;
